<template>
  <div class="power container">
    <ego-title :title="title"  :subtitle="subtitle" class="power-title"></ego-title>
    <div class="content">
      <div class="item" v-for="(item, index) in itemList" :key="item + '' + index">
        <div class="left">
          <img :src="item.imgSrc" class="image">
        </div>
        <div class="right">
          <p class="right-title">{{item.title}}</p>
          <p class="right-text">{{item.text}}</p>
        </div>
      </div>
    </div>
    <div class="power-button">
      <router-link to="/join" target="_blank">
        <tgoButton :use="isMobile ? 'mobile bg' : 'bg'">更多权益展示</tgoButton>
      </router-link>
    </div>
  </div>
</template>
<script>
import egoTitle from '@/base/ego-title'
import tgoButton from '@/base/ego-button-new'

export default {
  data () {
    return {
      itemList: [
        {
          imgSrc: require('../../../assets/icons/ren.png'),
          title: '八人制智囊团',
          text: '8 名经过审核和面试的学员组成私密小组，每月进行 4 个小时的线下深度交流'
        },
        {
          imgSrc: require('../../../assets/icons/xuexi.png'),
          title: '月度放松学习',
          text: '全球 12 座城市，每个月 12 场主题活动，专题研讨、管理问诊、名企拜访无所不包'
        },
        {
          imgSrc: require('../../../assets/icons/tuandui.png'),
          title: '助力团队成长',
          text: '团队和企业尊享极客时间 APP 企业版、QCon、ArchSummit 和 GTLC 的优惠折扣'
        },
        {
          imgSrc: require('../../../assets/icons/jiaoliu.png'),
          title: '跨城交流互动',
          text: '全球 12 座城市间的跨城交流，均有 TGO 鲲鹏会工作人员和学员志愿担任的服务委员进行招待'
        },
        {
          imgSrc: require('../../../assets/icons/huiyiting.png'),
          title: '宣传展示曝光',
          text: '学员个人或企业可通过极客邦科技的全媒体传播渠道进行立体式的宣传及曝光'
        },
        {
          imgSrc: require('../../../assets/icons/quanqiu.png'),
          title: '线上链接全球',
          text: '线上社区涵盖了小组、城市、全球学员三个级别，随时随地联系全球优秀学员和企业'
        }
      ]
    }
  },
  props: ['isMobile', 'events'],
  components: {
    egoTitle,
    tgoButton
  },
  computed: {
    title () {
      return '丰富权益，助力成长'
    },
    subtitle () {
      if (this.isMobile) {
        return '成为学员，可享受 <span style="font-size:18px;color: #D7B375;font-weight: 500">10+</span> 项不同的权益，让您和您的企业探索出技术和业务发展的无限可能'
      } else {
        return '成为学员，可享受 <span style="font-size:24px;color: #D7B375;font-weight: 500">10+</span> 项不同的权益，让您和您的企业探索出技术和业务发展的无限可能'
      }
    },
    word () {
      return '更多权益展示'
    }
  }
}
</script>
<style scoped lang='scss'>
@import '../../../style/bulma/app.sass';

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 80vw;
    margin-top: 40px;
    margin-bottom: 40px;
    font-family:PingFang SC;
    @include mobile {
      width: 92vw;
    }

    .power-title {
      margin: 0 auto 50px;
      @include mobile {
        width: 95%;
        margin-bottom: 10px;
      }
    }

    .content {
      width: 1080px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 30px;
      @include mobile {
        width: 92vw;
        margin-top: -20px;
      }
      .item {
        display: flex;
        align-items: center;
        width: 330px;
        height: 90px;
        display: flex;
        margin-bottom: 50px;
        @include mobile {
          // width: 92vw;
          margin-bottom: 16px;
          &:first-of-type {
            margin-top: 40px;
          }
        }
        .left {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 2px solid rgba(215, 179, 117, 0.6);
          margin-right: 20px;
          .image {
            width: 40px;
            @include mobile {
              width: 35px;
            }
          }
          @include mobile {
            width: 70px;
            height: 70px;
          }
        }
        .right {
          flex: 1 1;
          text-align: justify;
          .right-title {
            font-size: 20px;
            font-weight: 500;
            margin: 0;
            @include mobile {
              font-size: 18px;
            }
          }
          .right-text {
            color: #6E6E6E;
            font-size: 14px;
            line-height: 19px;
            font-weight: 400;
            margin: 0;
          }
        }
      }
    }

    .power-button {
      margin: 0 auto;
      margin-bottom: 40px;
      width: 350px;
      @include mobile {
        width: 86%;
        margin-bottom: 0px;
      }
    }
  }
</style>
